import en from './en'
import ru from './ru'

export default {
  en,
  ru
}



// WEBPACK FOOTER //
// ./src/intl/index.js